import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MppHeaderComponent, MppFooterComponent } from './MppHeaderFooter';
// Component
import SessionHandler from '../../contactUs/containers/SessionHandler';
import HeroModuleSession from '../../contactUs/containers/HeroModule';
import ContactOptionsLinksFooter from '../../contactUs/components/ContactOptionsLinksFooter';
import AlertsContainer from '../../contactUs/containers/Alerts';

// Container
import NavHome from '../containers/NavHome';
import ModalContainer from '../../contactUs/containers/ModalContainer';
import ChatInEligibleModalContainer from '../../contactUs/containers/ChatInEligibilityModalContainer';
import DisputeAlert from '../../contactUs/containers/DisputeAlert';
import IcfArticlesContainer from '../containers/IcfArticlesContainer';
import { trackPage } from '../../lib/analytics-helper';

class App extends Component {
  constructor(props) {
    super(props);
    this.sidebarEl = this.sidebarEl.bind(this);
    this.mainContainerEl = this.mainContainerEl.bind(this);
  }

  sidebarEl() {
    const { sideBar } = this.props;
    return (
      <div className="side-bar side-bar__grid">
        { sideBar }
      </div>
    );
  }

  mainContainerEl() {
    const { mainContainer } = this.props;
    return (
      <div id="main-container" className="main-container main-container__grid" tabIndex="0" aria-label="">
        <div className="main-container-contents">
          { mainContainer }
        </div>
      </div>
    );
  }

  renderHomePage() {
    const pathName = this.props.location && this.props.location.pathname;
    const icfPage = pathName.indexOf('/guide') >= 0;
    if (icfPage) {
      trackPage({ id: 'ICFPage', link: 'smarthelp-home-icf-articles' });
      return (
        <IcfArticlesContainer />
      );
    }
    return (
      <div className="page-main-container" role="main">
        <div id="refund-alert" name="search" />
        <DisputeAlert />
        <AlertsContainer />
        <NavHome />
        <ModalContainer FPTITrackerId="articleintermediatePage" />
        <ChatInEligibleModalContainer />
        <div className="page-body-container">
          {this.sidebarEl()} {this.mainContainerEl()}
        </div>
        <ContactOptionsLinksFooter />
      </div>
    );
  }

  render() {
    return (
      <div>
        <MppHeaderComponent />
        <div className="vx_mainContent">
          <SessionHandler />
          <HeroModuleSession />
          <div className="page-main-container" role="main">
            {this.renderHomePage()}
          </div>
        </div>
        <MppFooterComponent />
      </div>
    );
  }
}

App.propTypes = {
  sideBar: PropTypes.element.isRequired,
  mainContainer: PropTypes.element.isRequired,
  location: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    location: state.location,
  };
}

export default connect(mapStateToProps, null)(App);
